var exports = {
  "h_": "x620889e6--d26e0b--description",
  "Qq": "x620889e6--d26e0b--text",
  "FY": "x620889e6--d26e0b--paragraph",
  "gi": "x620889e6--d26e0b--paragraph-clamped",
  "L$": "x620889e6--d26e0b--toggle",
  "Kk": "x620889e6--d26e0b--icon",
};

module.exports = exports;
